// import _ from 'lodash';
import { Vue } from 'ui.vue';
import { Loc } from 'main.core';
import { CurrencyCore } from "currency.currency-core";
import { userStore } from 'germes.multibasket';
import { analytics } from 'germes.analytics';

userStore.registerModule('basket', {
    namespaced: true,
    state: {
        ID: null,
        ACCOUNT_NUMBER: null,
        ADDRESS_ID: null,
        CONTRAGENT_ID: null,
        ITEMS: {},
        USER: {
            ID: null,
            XML_ID: null
        },
        basketPriceDiscountError: null,
        // params
        error: {
            payment: {},
            delivery: {},
            user_rops: {},
        },
        initHandler: false,
        submited: false,
        status: false,
        // static props!
        basketUrl: '/catalog/?action=ADD2BASKET&id=#ID#',
        // basketUrl: '/local/tools/ajax_multibasket.php?action=ADD2BASKET&id=#ID#',
        basketPageURL: '/personal/order/',
    },
    mutations: {
        setBasket: function (state, basket) {
            if (basket == undefined) {
                this.dispatch('showNotificate', { message: 'Не смогли загрузить пустую корзину!' });
            } else {
                let event = { basket: basket, result: true };
                BX.onCustomEvent("OnBeforeBasketSet", event);
                if (event.result === true) {
                    this.commit('basket/updateBasket', basket);
                    state.CUR_BASKET_ID = basket.ID;
                    BX.onCustomEvent("OnAfterBasketSet", event);
                }
            }
        },
        updateBasket: function (state, basket) {
            for (const code in basket) {
                if (Object.hasOwnProperty.call(basket, code)) {
                    if (code == "ITEMS") {
                        Vue.set(state, code, {});
                        this.dispatch('basket/updateBasketItems', basket[code]);
                    } else {
                        Vue.set(state, code, basket[code]);
                    }
                }
            }
        },
        updateBasketInList: function (state, basketObj) {
            // TODO временно, пока список корзин в глобальном сторе (нужно переносить в модуль корзины)
            if (basketObj['ID'] != undefined) {
                Vue.set(state.data.user.BASKETS, basketObj['ID'], basketObj);
            }
        },
        removeBasketInList: function (state, basketObj) {
            // TODO временно, пока список корзин в глобальном сторе (нужно переносить в модуль корзины)
            if (basketObj['ID'] != undefined) {
                Vue.delete(state.data.user.BASKETS, basketObj['ID'], basketObj);
            }
        },
        // Update store values
        updateItemsPrice: function (state, newPriceList) {
            if (newPriceList != undefined) {
                for (const itemid in newPriceList) {
                    if (Object.hasOwnProperty.call(newPriceList, itemid)) {
                        let basketItem = this.getters['basket/findItem'](itemid);
                        Vue.set(basketItem, 'BASE_PRICE', newPriceList[itemid].BASE_PRICE);
                        Vue.set(basketItem, 'PRICE', newPriceList[itemid].PRICE);
                    }
                }
            } else {
                this.dispatch('showNotificate', { message: 'Цены в корзине не обновлены!' });
            }
        },
        updateBasketItem: function (state, element) {
            let event = { item: element, result: true };
            // BX.onCustomEvent("OnBeforeBasketUpdateProduct", event);
            BX.onCustomEvent("OnBeforeBasketElementUpdate", event);
            if (event.result === true) {
                if (event.item) element = Object.assign({}, element, event.item);
                if (element.CAN_BUY_IN_PERCENT == undefined) element.CAN_BUY_IN_PERCENT = 0;
                Vue.set(state.ITEMS, element.PRODUCT_ID, element);
                for (const key in element) {
                    if (Object.hasOwnProperty.call(element, key)) {
                        Vue.set(state.ITEMS[element.PRODUCT_ID], key, element[key]);
                    }
                }
                // BX.onCustomEvent("OnAfterBasketUpdateProduct", element);
                BX.onCustomEvent("OnAfterBasketElementUpdate", element);
            }
        },
        // Change active store values
        setAddressId: function (state, id) {
            if (id === 0) {
                state.ADDRESS_ID = this.getters['basket/getContragent']?.ADDRESS[id].ID;
                this.state.data.user.ACTIVE_ADDRESS = state.ADDRESS_ID // TODO убрать когда-нибудь!
            } else if (id != undefined && this.getters['basket/getContragent']?.ADDRESS[id]) {
                let saveAddressId = parseInt(state.ADDRESS_ID),
                    addressObj = this.getters['basket/getContragent']?.ADDRESS[id],
                    event = { address: addressObj, return: true };

                BX.onCustomEvent('OnBeforeAddressChange', event);
                if (event?.return == true) {
                    let data = {
                        action: 'changeAddress',
                        basket_id: this.getters['basket/basket_id'],
                        address_id: id,
                    };
                    state.ADDRESS_ID = addressObj.ID;
                    this.dispatch('submit', data).then(response => {
                        if (response?.address?.ID) {
                            state.ADDRESS_ID = response.address.ID;
                        }
                        this.state.data.user.ACTIVE_ADDRESS = state.ADDRESS_ID // TODO убрать когда-нибудь!
                        this.dispatch('showNotificate', { message: this.getters['basket/localize']('ADDRESS_CHANGED_Y'), category: 'BasketAddressChange' });
                        BX.onCustomEvent('OnAfterAddressChange', event);
                        // BX.onCustomEvent("OnBasketChange");
                    }, error => {
                        state.ADDRESS_ID = saveAddressId;
                        this.dispatch('showNotificate', { message: this.getters['basket/localize']('ADDRESS_CHANGED_N'), category: 'BasketAddressChange' });
                        console.error(error);
                    });
                }
            } else {
                this.dispatch('showNotificate', { message: this.getters['basket/localize']('ADDRESS_CHANGED_N'), category: 'BasketAddressChange' });
            }
        },
        changeAddress: function (state, params) {
            if (typeof params == 'object' && params.id != undefined) params = params.id;
            console.warn("// DEPRECATED changeAddress use setAddressId(int address_id)");
            this.commit('basket/setAddressId', params);
        },
        setContragentId: function (state, id) {
            if (id != undefined && this.getters.getContragents[id]) {
                let saveContragentId = parseInt(state.CONTRAGENT_ID),
                    contragentObj = this.getters.getContragents[id],
                    event = { contragent: contragentObj, return: true };

                BX.onCustomEvent('OnBeforeContragentChange', event);
                if (event.return == true && contragentObj.ID) {
                    let data = {
                        action: 'changeContragent',
                        basket_id: this.getters['basket/basket_id'],
                        contragent_id: contragentObj.ID,
                    };
                    state.CONTRAGENT_ID = contragentObj.ID;
                    this.dispatch('submit', data).then(response => {
                        if (response?.contragent?.ID) {
                            state.CONTRAGENT_ID = response.contragent.ID;
                        }
                        // this.state.data.user.ACTIVE_CONTRAGENT = state.CONTRAGENT; // TODO убрать когда-нибудь!
                        // BX.setCookie(state.data.user.ID + '_ACTIVE_CONTRAGENT_ID', params.ID, { secure: false, path: '/' });
                        // INFO сохраняем зависимость адреса доставки от контраегнта
                        if (this.getters.getContragents[state.CONTRAGENT_ID]?.ADDRESS) {
                            let addressids = Object.keys(this.getters.getContragents[state.CONTRAGENT_ID].ADDRESS);
                            let address_id = 0;
                            if (addressids.length == 1) {
                                address_id = parseInt(this.getters.getContragents[state.CONTRAGENT_ID].ADDRESS[addressids[0]].ID);
                                this.commit('basket/setAddressId', address_id);
                            }
                            state.ADDRESS_ID = address_id;
                        }
                        this.dispatch('showNotificate', { message: this.getters['basket/localize']('CONTRAGENT_CHANGED_Y'), category: 'BasketContragentChange' });
                        BX.onCustomEvent('OnAfterContragentChange', event);
                        // BX.onCustomEvent('OnAfterContragentChange', this.getters.getContragents[state.CONTRAGENT_ID]);
                        // BX.onCustomEvent("OnBasketChange");
                    }, error => {
                        state.CONTRAGENT_ID = saveContragentId;
                        this.dispatch('showNotificate', { message: this.getters['basket/localize']('CONTRAGENT_CHANGED_N'), category: 'BasketContragentChange' });
                        console.error(error);
                    });
                }
            } else {
                this.dispatch('showNotificate', { message: this.getters['basket/localize']('CONTRAGENT_CHANGED_N'), category: 'BasketContragentChange' });
            }
        },
        changeContragent: function (state, params) {
            if (typeof params == 'object' && params.id != undefined) params = params.id;
            console.warn("// DEPRECATED changeContragent use setContragentId(int contragent_id)");
            this.commit('basket/setContragentId', params);
        },
        changeBasket: function (state, params) {
            if (
                params != undefined &&
                params.ID &&
                params.ITEMS &&
                state.data.user.BASKETS[params.ID]
            ) {
                state.data.user.BASKET_ID = params.ID;
            } else {
                this.dispatch('showNotificate', { message: 'Корзина не изменена!' });
            }
        },
        addBasket: function (state, basket) {
            if (basket.ID) {
                Vue.set(this.state.data.user.BASKETS, basket.ID, basket);
            } else {
                console.error("No basket to addBasket");
            }
        },
        deleteBasket: function (state, basket) {
            if (basket?.ID) {
                let event = { basket: this.getters.getBasketList[basket.ID], result: true };
                BX.onCustomEvent("OnBeforeBasketDelete", event);
                if (event.result == true) {
                    Vue.delete(this.getters.getBasketList, basket.ID);
                    BX.onCustomEvent("OnAfterBasketDelete", event);
                }
            } else {
                console.error("No basket to deleteBasket");
            }
        },
        clearBasket: function (state, basket) {
            if (basket?.ID != undefined && basket.ID != this.getters['basket/getBasketId']) {
                let event = { basket: this.getters.getBasketList[basket.ID], result: true };
                BX.onCustomEvent("OnBeforeBasketClear", event);
                if (event.result == true) {
                    Vue.set(this.getters.getBasketList[basket.ID], 'ITEMS', {});
                    BX.onCustomEvent("OnAfterBasketClear", event);
                }
            } else if (basket == undefined) {
                let event = { basket: state, result: true };
                BX.onCustomEvent("OnBeforeBasketClear", event);
                if (event.result == true) {
                    Vue.set(state, 'ITEMS', {});
                    BX.onCustomEvent("OnAfterBasketClear", event);
                }
            } else {
                console.error("No basket to clear");
            }
        },
        // Add store values
        addContragent: function (state, contragent) {
            if (contragent.ID &&
                contragent.NAME
            ) {
                state.data.user.CONTRAGENTS[contragent.ID] = contragent;
                if (contragent.ID == state.data.user.ACTIVE_CONTRAGENT.ID) {
                    state.commit('changeContragent', { id: contragent.ID });
                }
            }
        },
        addContragentAddress: function (state, address) {
            if (address.ID &&
                address.CONTRAGENT_ID &&
                address.NAME
            ) {
                if (!state.data.user.CONTRAGENTS[address.CONTRAGENT_ID].ADDRESS)
                    state.data.user.CONTRAGENTS[address.CONTRAGENT_ID].ADDRESS = {};

                state.data.user.CONTRAGENTS[address.CONTRAGENT_ID].ADDRESS[address.ID] = address;
                if (address.ID == state.data.user.ACTIVE_ADDRESS.ID) {
                    // this.commit('changeAddress', address);
                }
                this.dispatch('showNotificate', { message: 'Добавлен адрес контрагента!' });
            } else {
                this.dispatch('showNotificate', { message: 'Не удалось добавить адрес контрагента!' });
            }
        },
        // Products
        addProduct: async function (state, product) {
            let oldProduct = this.getters['basket/findItem'](product.PRODUCT_ID || product.ID);
            if (oldProduct?.PRODUCT_ID === undefined) {
                let newProduct = Object.assign({}, product);
                newProduct.CML2_ARTICLE = newProduct.XML_ID.replace(/(.)*#/i, '');
                if (!newProduct.PRODUCT_ID) newProduct.PRODUCT_ID = newProduct.ID;
                if (!newProduct.BASE_PRICE) newProduct.BASE_PRICE = newProduct.PRICE;
                let event = { product: newProduct, result: true };
                BX.onCustomEvent("OnBeforeBasketAddProduct", event);
                if (event.result === true) {
                    let submitData = this.getters['basket/getPostData'](newProduct, 'add');
                    this.dispatch('submit', submitData).then(response => {
                        newProduct = Object.assign({}, newProduct, response.data);
                        Vue.set(state.ITEMS, newProduct.PRODUCT_ID, newProduct);
                        this.dispatch('showNotificate', {
                            message: Loc.getMessage("NOTIFICATE_BASKET_ADD_PRODUCT")
                                .replace(/#CML2_ARTICLE#/gi, newProduct.CML2_ARTICLE)
                                .replace(/#NAME#/gi, newProduct.NAME)
                                .replace(/#ID#/gi, newProduct.ID)
                                .replace(/#QUANTITY#/gi, parseFloat(newProduct.QUANTITY)),
                            category: newProduct.PRODUCT_ID,
                            actions: [
                                {
                                    title: (this.getters['basket/localize']('VUE_GO_TO_CART') || "View cart"),
                                    href: state.basketPageURL,
                                    events: {
                                        click: BX.delegate(function (event, balloon, action) {
                                            balloon.close();
                                            if (state.basketPageURL) window.location.href = state.basketPageURL;
                                        }, this),
                                    }
                                }
                            ]
                        });
                        BX.onCustomEvent("OnAfterBasketAddProduct", newProduct);
                        BX.onCustomEvent("OnAfterBasketElementUpdate", newProduct);
                    }, error => {
                        console.error("ERROR rollback")
                        console.debug(error);
                    });
                }
            } else {
                // BX.onCustomEvent("OnBasketChange");
                this.dispatch('showNotificate', {
                    message: "Продукт не найден в корзине для обновления, обновите страницу или сообщите в чат поддержки."
                });
                console.debug(product);
            }
        },
        deleteProduct: async function (state, product) {
            let oldProduct = this.getters['basket/findItem'](product.PRODUCT_ID || product.ID);
            if (oldProduct.PRODUCT_ID !== undefined) {
                let event = { product: oldProduct, result: true };
                BX.onCustomEvent("OnBeforeBasketDeleteProduct", event);
                if (event.result === true && state.ITEMS[oldProduct.PRODUCT_ID] !== undefined) {
                    Vue.delete(state.ITEMS, oldProduct.PRODUCT_ID);
                    oldProduct.CML2_ARTICLE = oldProduct.XML_ID.replace(/(.)*#/i, '');
                    oldProduct.QUANTITY = 0;
                    let submitData = this.getters['basket/getPostData'](oldProduct, 'delete');
                    await this.dispatch('submit', submitData).then(response => {
                        this.dispatch('showNotificate', {
                            message: Loc.getMessage("NOTIFICATE_BASKET_DELETE_PRODUCT")
                                .replace(/#CML2_ARTICLE#/gi, oldProduct.CML2_ARTICLE)
                                .replace(/#NAME#/gi, oldProduct.NAME)
                                .replace(/#ID#/gi, oldProduct.ID)
                                .replace(/#QUANTITY#/gi, parseFloat(oldProduct.QUANTITY)),
                            category: oldProduct.PRODUCT_ID
                        });
                        BX.onCustomEvent("OnAfterBasketDeleteProduct", oldProduct);
                        BX.onCustomEvent("OnAfterBasketElementUpdate", oldProduct);
                    }, error => {
                        console.error("ERROR rollback")
                        Vue.set(state.ITEMS, oldProduct.PRODUCT_ID, oldProduct);
                        console.debug(error);
                    });
                }
            } else {
                // BX.onCustomEvent("OnBasketChange");
                await this.dispatch('showNotificate', {
                    message: "Продукт не найден в корзине для удаления, обновите страницу или сообщите в чат поддержки."
                });
                console.debug(product);
            }
        },
        updateProduct: async function (state, product) {
            let oldProduct = this.getters['basket/findItem'](product.PRODUCT_ID || product.ID);
            if (oldProduct.PRODUCT_ID !== undefined) {
                let newProduct = Object.assign({}, oldProduct, product);
                // delete (newProduct.ID); // INFO important to delete any other ID
                newProduct.CML2_ARTICLE = newProduct.XML_ID.replace(/(.)*#/i, '');
                let event = { product: newProduct, result: true };
                BX.onCustomEvent("OnBeforeBasketUpdateProduct", event);
                if (event.result === true && state.ITEMS[oldProduct.PRODUCT_ID] !== undefined) {
                    Vue.set(state.ITEMS, oldProduct.PRODUCT_ID, newProduct);
                    let submitData = this.getters['basket/getPostData'](newProduct, 'update');
                    await this.dispatch('submit', submitData).then(response => {
                        newProduct = Object.assign({}, newProduct, response.data, { ID: oldProduct.ID });
                        Vue.set(state.ITEMS, newProduct.PRODUCT_ID, newProduct);
                        this.dispatch('showNotificate', {
                            message: Loc.getMessage("NOTIFICATE_BASKET_UPDATE_PRODUCT")
                                .replace(/#CML2_ARTICLE#/gi, newProduct.CML2_ARTICLE)
                                .replace(/#NAME#/gi, newProduct.NAME)
                                .replace(/#ID#/gi, newProduct.ID)
                                .replace(/#QUANTITY#/gi, parseFloat(newProduct.QUANTITY)),
                            category: newProduct.PRODUCT_ID,
                            actions: [
                                {
                                    title: (this.getters['basket/localize']('VUE_GO_TO_CART') || "View cart"),
                                    href: state.basketPageURL,
                                    events: {
                                        click: BX.delegate(function (event, balloon, action) {
                                            balloon.close();
                                            if (state.basketPageURL != undefined) window.location.href = state.basketPageURL;
                                        }, this),
                                    }
                                }
                            ]
                        });
                        BX.onCustomEvent("OnAfterBasketUpdateProduct", newProduct);
                        BX.onCustomEvent("OnAfterBasketElementUpdate", newProduct);
                    }, error => {
                        console.error("ERROR rollback")
                        Vue.set(state.ITEMS, oldProduct.PRODUCT_ID, oldProduct);
                        console.debug(error);
                    });
                }
            } else {
                // BX.onCustomEvent("OnBasketChange");
                await this.dispatch('showNotificate', {
                    message: "Product definition error, please report to technical support"
                });
                console.debug(product);
            }
        },
        setBasketDescription: function (state, value) {
            let data = {
                action: 'changeDescription',
                basket_id: this.getters['basket/basket_id'],
                description: value,
            };
            let description_old = state.DESCRIPTION;
            state.DESCRIPTION = value;
            this.dispatch('submit', data).then(response => {
                state.DESCRIPTION = value;
                // this.dispatch('showNotificate', { message: this.getters['basket/localize']('DESCRIPTION_CHANGED_Y'), category: 'BasketDescriptionChange' });
                BX.onCustomEvent("OnBasketChangeDescription", data);
            }, error => {
                state.DESCRIPTION = description_old;
                this.dispatch('showNotificate', {
                    message: error.errors?.join(' ') ?? this.getters['basket/localize']('DESCRIPTION_CHANGED_N'),
                    category: 'BasketDescriptionChange'
                });
            });
        },
        // Remove any prop
        removeData: function (state, propName) {
            if (typeof state[propName] != 'undefined') Vue.set(state, propName, null);
        },
    },
    actions: {
        // INFO отложенная отправка на сервер!
        send2Server: /* _.debounce(async  */(store, data) => {
            return new Promise((resolve, reject) => {
                try {
                    if (typeof data != 'object') throw "No data to send";
                    if (data.ID && (!data.PRODUCT_ID || data.PRODUCT_ID == undefined)) data.PRODUCT_ID = data.ID; // TODO убрать костыль!
                    var postData = store.getters.getPostData(data);
                    store.state.status = 'loading';
                    BX.ajax({
                        url: postData.url,
                        data: postData,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 60,
                        async: true,
                        cache: false,
                        onsuccess: BX.proxy(function (result) {
                            if (result != null && result.STATUS == "ERROR") {
                                store.dispatch('errorSend2Server', { item: data, type: result });
                                reject(false);
                            } else {
                                resolve(result);
                            }
                            store.state.status = null;
                        }, store),
                        onfailure: BX.proxy(function (error) {
                            store.dispatch('errorSend2Server', { item: data, type: error });
                            reject(false);
                            store.state.status = null;
                        }, store),
                    });
                } catch (error) {
                    store.dispatch('errorSend2Server', { item: data, type: error });
                    reject(false);
                }
            });
        }/* , 1000) */,
        initEventHandler: function (store) {
            if (!store.state.initHandler) {
                BX.addCustomEvent("OnAfterContragentChange", BX.proxy(function (event) {
                    try {
                        BX.onCustomEvent('OnBeforeBasketUpdatePrice');
                        let data = {
                            action: 'getPrice',
                            items_id: this.getters['basket/getItemsXML_ID']
                        }
                        if (data.items_id != undefined && Object.keys(data.items_id)?.length) {
                            this.dispatch('submit', data).then(response => {
                                this.commit('basket/updateItemsPrice', response.data);
                                this.dispatch('showNotificate', { message: this.getters['basket/localize']('UPDATE_PRICE_Y'), category: 'OnCatalogUpdatePrice' });
                                BX.onCustomEvent('OnAfterBasketUpdatePrice');
                            }, error => {
                                this.dispatch('showNotificate', { message: this.getters['basket/localize']('UPDATE_PRICE_N'), category: 'OnCatalogUpdatePrice' });
                                throw error;
                            });
                        }
                    } catch (error) {
                        console.debug(error);
                    }
                }, this));
                BX.addCustomEvent("OnAfterBasketUpdatePrice", BX.delegate(function () {
                    if (!this?.getters['isLoading']) {
                        BX.onCustomEvent('OnBasketChange');
                    }
                }, this));
                // BX.addCustomEvent("OnAfterBasketElementUpdate", BX.delegate(function () {
                //     if (!this?.getters['isLoading']) {
                //         BX.onCustomEvent('OnBasketChange');
                //     }
                // }, this));
                // TODO add analitycs for action event
                BX.addCustomEvent("OnAfterBasketAddProduct", BX.delegate(function () {
                    if (!this?.getters['isLoading']) {
                        BX.onCustomEvent('OnBasketChange');
                    }
                    // this.setAnalyticsDataLayer('addToCart')
                }, this));
                BX.addCustomEvent("OnAfterBasketDeleteProduct", BX.delegate(function () {
                    if (!this?.getters['isLoading']) {
                        BX.onCustomEvent('OnBasketChange');
                    }
                    // this.setAnalyticsDataLayer('removeFromCart')
                }, this));
                // BX.addCustomEvent("OnAfterBasketUpdateProduct", BX.delegate(function() {
                //     this.setAnalyticsDataLayer('addToCart')
                // }, this));
                BX.ready(BX.proxy(function () {
                    BX.onCustomEvent("OnAfterBasketStoreInit");
                }, this));
                store.state.initHandler = true;
            }
        },
        updateBasketList: function (state, basketList) {
            if (basketList !== undefined && basketList !== null && Object.keys(basketList)?.length !== 0) {
                for (const id in basketList) {
                    if (Object.hasOwnProperty.call(basketList, id)) {
                        this.commit('basket/updateBasketInList', basketList[id]);
                    }
                }
            } else {
                Vue.set(state, 'ITEMS', {});
                // this.dispatch('showNotificate', { message: 'Товары в корзине не обновлены!' });
            }
        },
        updateBasketItems: function (state, itemList) {
            if (itemList !== undefined && itemList !== null && Object.keys(itemList)?.length !== 0) {
                for (const id in itemList) {
                    if (Object.hasOwnProperty.call(itemList, id)) {
                        this.commit('basket/updateBasketItem', itemList[id]);
                    }
                }
            } else {
                Vue.set(state, 'ITEMS', {});
                // this.dispatch('showNotificate', { message: 'Товары в корзине не обновлены!' });
            }
        },
        setProductProperty: function (store, params) {
            let cartProduct = this.getters['basket/findItem'](params.PRODUCT_ID);
            if (cartProduct?.PRODUCT_ID !== undefined) {
                let event = { product: cartProduct, result: true };
                BX.onCustomEvent("OnBeforeBasketUpdateProductProperty", event);
                if (event.result === true) {
                    var data = {
                        action: 'addBasketItemProperty',
                        product_xml_id: cartProduct.XML_ID,
                        product_id: cartProduct.PRODUCT_ID,
                        properties: params.PROPS,
                        PRODUCT_XML_ID: cartProduct.XML_ID,
                        PRODUCT_ID: cartProduct.PRODUCT_ID,
                        PROPS: params.PROPS
                    };
                    Vue.set(store.state.ITEMS[cartProduct.PRODUCT_ID], 'PROPS', Object.assign({}, cartProduct.PROPS, params.PROPS));
                    data = this.getters['basket/getPostData'](data, 'props');
                    return this.dispatch('submit', data)
                        .then(response => {
                            if (event.product !== undefined) cartProduct = Object.assign(cartProduct, event.product);
                            this.commit('basket/updateBasketItem', cartProduct);
                            BX.onCustomEvent("OnAfterBasketUpdateProductProperty", event);
                        }, error => {
                            Vue.set(store.state.ITEMS[cartProduct.PRODUCT_ID], 'PROPS', cartProduct.PROPS);
                            console.error("Got nothing from server, please report to technical support")
                            console.debug(error);
                        });
                }
            } else {
                console.debug(params);
                return this.dispatch('showNotificate', {
                    message: "Product definition error, please report to technical support"
                });
            }
        },
    },
    getters: {
        localize: (state) => (CODE) => {
            return BX.message(CODE);
        },
        getPostData: (state) => (postedData, type) => {
            if (typeof postedData == 'object' && postedData.PRODUCT_ID !== undefined) {
                // временное решение пока не разберу весь мусор
                if (type) {
                    var basketUrl = '/bitrix/services/main/ajax.php';
                    var controllerData = {
                        'cartId': state.ID,
                        'productData': postedData
                    };
                    switch (type) {
                        case 'check':
                            controllerData.url = basketUrl + '?action=germes:multibasket.cart.checkProduct'
                            break;
                        case 'props':
                            controllerData.url = basketUrl + '?action=germes:multibasket.cart.updateProductProps'
                            break;
                        case 'add':
                            controllerData.url = basketUrl + '?action=germes:multibasket.cart.addProduct'
                            break;
                        case 'delete':
                            controllerData.url = basketUrl + '?action=germes:multibasket.cart.deleteProduct'
                            break;
                        default:
                            controllerData.url = basketUrl + '?action=germes:multibasket.cart.updateProduct'
                            break;
                    }
                    controllerData.action = 'test';
                    return controllerData;
                }
                postedData.url = state.basketUrl?.replace('#ID#', postedData.PRODUCT_ID?.toString());
                postedData.productId = postedData.PRODUCT_ID?.toString();
                postedData.ajax_basket = 'Y';
                postedData.action = 'ADD2BASKET';
                if (postedData.ANALOG === 'Y') postedData.PLACEMENT = "analog";
                else if (window.location.pathname.indexOf('catalog/')) postedData.PLACEMENT = "catalog";
                else if (window.location.pathname.indexOf('actions/')) postedData.PLACEMENT = "actions";
                else if (window.location.pathname.indexOf('order/') && window.location.hash == '#import-basket-tab') postedData.PLACEMENT = "import";
                if (typeof postedData.QUANTITY != 'undefined') {
                    postedData.quantity = postedData.QUANTITY;
                }
                return postedData;
            } else {
                throw "Error! Empty postedData";
            }
        },
        // TODO optimyze me
        findItem: (state, getters) => (find_product_str) => {
            let product = getters.getItems[find_product_str] || {};
            if (!product?.ID && getters.getItems) {
                for (const i in getters.getItems) {
                    if (Object.hasOwnProperty.call(getters.getItems, i) &&
                        (getters.getItems[i].PRODUCT_ID == find_product_str
                            || getters.getItems[i].PRODUCT_XML_ID == find_product_str
                            || getters.getItems[i].XML_ID == find_product_str
                        )) {
                        product = getters.getItems[i];
                        break;
                    }
                }
            }
            if (product.PRODUCT_XML_ID) product.PRODUCT_XML_ID = product.PRODUCT_XML_ID?.replace(/(.)*#/i, '');
            return product;
        },
        findItemIndex: (state, getters) => (find_product_str) => {
            let productIndex = null;
            if (!!getters.getItems) {
                for (const i in getters.getItems) {
                    if (Object.hasOwnProperty.call(getters.getItems, i) &&
                        (getters.getItems[i].PRODUCT_ID == find_product_str
                            || getters.getItems[i].PRODUCT_XML_ID == find_product_str
                            || getters.getItems[i].XML_ID == find_product_str
                        )
                    ) {
                        productIndex = i;
                        break;
                    }
                }
            }
            return productIndex;
        },
        getItemQuantity: (state, getters) => (find_product_str) => {
            return parseFloat(getters.findItem(find_product_str)?.QUANTITY || 0);
        },
        getItemPrice: (state, getters) => (find_product_str) => {
            return parseFloat(getters.findItem(find_product_str)?.PRICE || 0);
        },
        getQuantity: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED getQuantity use getItemsCount insted");
            return getters.getItemsCount;
        },
        getItems: (state) => {
            return state.ITEMS;
        },
        getItemsQuantity: (state, getters, rootState, rootGetters) => {
            let quantity = 0;
            if (getters.getItems !== null && typeof getters.getItems == 'object' && Object.keys(getters.getItems).length)
                for (const i in getters.getItems)
                    if (Object.hasOwnProperty.call(getters.getItems, i) && getters.getItems[i])
                        quantity += parseFloat(getters.getItems[i].QUANTITY);
            return quantity;
        },
        getItemsXML_ID: (state, getters, rootState, rootGetters) => {
            let result = {},
                itemList = getters.getItems;
            if (itemList !== null && typeof itemList == 'object' && Object.keys(itemList).length)
                for (const i in itemList)
                    if (Object.hasOwnProperty.call(itemList, i) && itemList[i])
                        result[i] = itemList[i].XML_ID;
            return result;
        },
        getItemsCount: (state, getters, rootState, rootGetters) => {
            return Object.keys(getters?.getItems)?.length;
        },
        getCurrency: (state, getters, rootState, rootGetters) => {
            return getters.getContragent?.CURRENCY || 'RUB';
        },
        //
        getBasketDescription: (state) => {
            return state.DESCRIPTION;
        },
        basketStatus: (state, getters, rootState, rootGetters) => {
            return state.status;
        },
        //
        basketPrice: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED basketPrice use getBasketPrice insted");
            return getters.getBasketPrice;
        },
        getBasketPrice: (state, getters, rootState, rootGetters) => {
            let price = 0;
            if (getters.getItems !== null && typeof getters.getItems == 'object' && Object.keys(getters.getItems).length) {
                for (const i in getters.getItems) {
                    if (Object.hasOwnProperty.call(getters.getItems, i) && getters.getItems[i]?.PRICE) {
                        price += parseFloat((getters.getItems[i].PRICE + "").replace(/\s+/, '')) * parseFloat(getters.getItems[i].QUANTITY);
                    }
                }
            }
            return parseFloat(price - getters.getBasketPriceDiscount);
        },
        getBasketPriceCurrency: (state, getters, rootState, rootGetters) => {
            if (BX.Currency && BX.Currency.currencyFormat) {
                return BX?.Currency?.currencyFormat(getters.basketPrice, getters.getCurrency, true).replace(/&nbsp;/gi, ' ');
            } else {
                return "";
            }
        },
        basketBasePrice: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED basketBasePrice use getBasketBasePrice insted");
            return getters.getBasketBasePrice;
        },
        getBasketBasePrice: (state, getters, rootState, rootGetters) => {
            let price = 0;
            if (getters.getItems !== null && typeof getters.getItems == 'object' && Object.keys(getters.getItems).length) {
                for (const i in getters.getItems) {
                    if (Object.hasOwnProperty.call(getters.getItems, i) && getters.getItems[i]?.PRICE) {
                        price += parseFloat((getters.getItems[i].PRICE + "").replace(/\s+/, '')) * parseFloat(getters.getItems[i].QUANTITY);
                    }
                }
            }
            return parseFloat(price);
        },
        getBasketBasePriceCurrency: (state, getters, rootState, rootGetters) => {
            return BX?.Currency?.currencyFormat(getters.getBasketBasePrice, getters.getCurrency, true)
                ?? getters.getBasketBasePrice;
        },
        basketPriceDiscount: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED basketPriceDiscount use getBasketPriceDiscount insted");
            return getters.getBasketPriceDiscount;
        },
        getBasketPriceDiscount: (state, getters, rootState, rootGetters) => {
            let sale = 0;
            if (rootGetters['bonus/getSaleType'] == "ORDER_BUY_PRODUCT_BONUS") {
                sale += rootGetters['bonus/getItemsInCartBuyBonusSum'];
            } else if (rootGetters['bonus/getSaleType'] == "ORDER_PROP_PAYED_FROM_ACCOUNT") {
                sale += rootGetters['bonus/getMaxBonusCartPrice'];
            } else if (getters.getItems !== null && typeof getters.getItems == 'object' && Object.keys(getters.getItems).length) {
                for (const i in getters.getItems) {
                    if (Object.hasOwnProperty.call(getters.getItems, i) && getters.getItems[i]?.DISCOUNT_PRICE) {
                        sale += parseFloat((getters.getItems[i].DISCOUNT_PRICE + "").replace(/\s+/, '')) * parseFloat(getters.getItems[i].QUANTITY);
                    }
                }
            }
            // TODO убрать прямое обращение к модулю бонусов!
            if (sale > rootGetters['bonus/getMaxBonusCartPrice']) {
                state.basketPriceDiscountError = Loc.getMessage("NOTIFICATE_BASKET_DISCOUNT_ERROR");
            } else {
                state.basketPriceDiscountError = null;
            }
            return parseFloat(sale);
        },
        getBasketPriceDiscountError: (state, getters, rootState, rootGetters) => {
            return state.basketPriceDiscountError;
        },
        getBasketPriceDiscountCurrency: (state, getters, rootState, rootGetters) => {
            if (BX.Currency && BX.Currency.currencyFormat) {
                return BX?.Currency?.currencyFormat(getters.getBasketPriceDiscount, getters.getCurrency, true).replace(/&nbsp;/gi, ' ');
            } else {
                return "";
            }
        },
        basketPriceAvailable: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED basketPriceAvailable use getBasketPriceAvailable insted");
            return getters.getBasketPriceAvailable;
        },
        getBasketPriceAvailable: (state, getters, rootState, rootGetters) => {
            let price = 0;
            if (getters.getItems !== null && typeof getters.getItems == 'object' && Object.keys(getters.getItems).length) {
                for (const i in getters.getItems) {
                    if (Object.hasOwnProperty.call(getters.getItems, i) && getters.getItems[i] && getters.getItems[i].CAN_BUY_IN_PERCENT) {
                        price += parseFloat((getters.getItems[i].BASE_PRICE + "").replace(/\s+/, '')) * parseInt(parseFloat(getters.getItems[i].QUANTITY) / 100 * parseFloat(getters.getItems[i].CAN_BUY_IN_PERCENT));
                    }
                }
            }
            return parseFloat(price);
        },
        getBasketPriceAvailableCurrency: (state, getters, rootState, rootGetters) => {
            if (BX.Currency && BX.Currency.currencyFormat) {
                return BX?.Currency?.currencyFormat(getters.getBasketPriceAvailable, getters.getCurrency, true).replace(/&nbsp;/gi, ' ');
            } else {
                return "";
            }
        },
        getBasketWeight: (state, getters, rootState, rootGetters) => {
            let weight = 0;
            if (getters.getItems !== null && typeof getters.getItems == 'object' && Object.keys(getters.getItems).length) {
                for (const i in getters.getItems) {
                    if (Object.hasOwnProperty.call(getters.getItems, i) && getters.getItems[i] && getters.getItems[i].WEIGHT) {
                        weight += parseFloat(getters.getItems[i].WEIGHT) * parseFloat(getters.getItems[i].QUANTITY);
                    }
                }
            }
            return parseFloat(weight.toFixed(2));
        },
        basketNumber: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED basketNumber use getBasketNumber insted");
            return getters.getBasketNumber;
        },
        getBasketNumber: (state) => {
            return state.ACCOUNT_NUMBER;
        },
        basketQuantity: (state, getters, rootState, rootGetters) => {
            return getters.getItems ? getters.getItems.length : 0;
        },
        contragent_id: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED contragent_id use getContragentId insted");
            return getters.getContragentId;
        },
        getContragentId: (state) => {
            return parseInt(state.CONTRAGENT_ID);
        },
        getContragent: (state, getters, rootState, rootGetters) => {
            return rootGetters.getContragents[state.CONTRAGENT_ID];
        },
        getContragentSource: (state, getters, rootState, rootGetters) => {
            return getters.getContragent?.UF_ISTOCHNIK?.toUpperCase();
        },
        getOwner: (state) => {
            return state.USER;
        },
        address_id: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED address_id use getAddressId insted");
            return getters.getAddressId;
        },
        getAddressId: (state, getters, rootState, rootGetters) => {
            if (getters.getContragent?.ADDRESS && !getters.getContragent?.ADDRESS[state.ADDRESS_ID]) {
                let addressids = Object.keys(getters.getContragent.ADDRESS);
                let address_id = 0;
                if (addressids.length == 1) {
                    address_id = parseInt(getters.getContragent.ADDRESS[addressids[0]].ID);
                }
                state.ADDRESS_ID = address_id;
            }
            return state.ADDRESS_ID ? parseInt(state.ADDRESS_ID) : 0;
        },
        getAddress: (state, getters, rootState, rootGetters) => {
            return (getters.getAddressId != null && getters.getContragent?.ADDRESS != undefined) ? getters.getContragent?.ADDRESS[getters.getAddressId] : {};
        },
        getId: (state) => {
            console.warn("// DEPRECATED basket_id use getBasketId insted");
            return parseInt(state.ID);
        },
        getBasketId: (state) => {
            return parseInt(state.ID);
        },
        basket_id: (state) => {
            console.warn("// DEPRECATED basket_id use getBasketId insted");
            return parseInt(state.ID);
        },
        getBasket: (state, getters, rootState, rootGetters) => {
            return state;
        },
        basket: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED basket use getBasket insted");
            return getters.getBasket;
        },
        userBasket: (state, getters, rootState, rootGetters) => {
            console.warn("// DEPRECATED userBasket use getBasket insted");
            return getters.getBasket;
        },
    },
});
userStore.dispatch('basket/initEventHandler');
